import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppStartupService, BaseComponent, RelatedCardDTO } from '@ridango/core';
import { NotificationFacade, RelatedCardFacade } from '@ridango/components';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'rwidget-add-edit-card-button',
    templateUrl: './add-edit-card-button.component.html',
    styleUrls: ['./add-edit-card-button.component.scss']
})
export class AddEditCardButtonComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() cardForm: FormGroup;
    @Input() isMobileView: boolean;
    @Input() mode: 'add' | 'edit';
    @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();
    subscriptionActionComplete: Subscription;
    subscriptionSuccess: Subscription;

    constructor(
        private appConfig: AppStartupService,
        private relatedCardFacade: RelatedCardFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.relatedCardFacade.resetRelatedCardStatus();
    }

    ngOnDestroy() {
        this.subscriptionActionComplete?.unsubscribe();
        this.subscriptionSuccess?.unsubscribe();
        super.ngOnDestroy();
    }

    submit() {
        if (this.cardForm?.invalid) {
            return;
        }

        if (this.mode == 'add') {
            this.submitNewCard();
        }
        if (this.mode == 'edit') {
            this.submitEditCard();
        }
    }

    private submitNewCard() {
        const cardPrefix = this.appConfig.getPropertyByCode('CARD_NUMBER_PREFIX') ?? '';
        this.initNotificationSubscription();
        this.relatedCardFacade.saveNewRelatedCard({
            card_nr: cardPrefix + this.cardForm.get('cardNr')?.value,
            card_pin: this.cardForm.get('cardPin')?.value,
            card_type: 'U',
            groups: this.cardForm.get('discountGroup')?.value,
            name: this.cardForm.get('name')?.value,
            region_id: this.appConfig.getRegion().region_id
        } as RelatedCardDTO);
    }

    private submitEditCard() {
        this.initNotificationSubscription();
        this.relatedCardFacade.selectedCard$.pipe(take(1)).subscribe((card) => {
            this.relatedCardFacade.saveEditedRelatedCard(card.id, {
                name: this.cardForm.get('name')?.value,
                groups: this.cardForm.get('discountGroup')?.value
            });
        });
    }

    private initNotificationSubscription() {
        this.subscriptionActionComplete?.unsubscribe();
        this.subscriptionActionComplete = this.relatedCardFacade.isActionCompleted$.subscribe((isActionComplete) => {
            if (isActionComplete) {
                this.relatedCardFacade.error$.pipe(take(1)).subscribe((e) => {
                    if (e?.error) {
                        if (e?.error?.description) {
                            this.notification.error(this.translate.instant(e.error.description));
                        } else {
                            this.notification.error(this.translate.instant(e.error));
                        }
                        this.subscriptionActionComplete.unsubscribe();
                    } else {
                        if (this.mode == 'edit') {
                            this.relatedCardFacade.fetchAllRelatedCards();
                            return (this.subscriptionSuccess = this.relatedCardFacade.loaded$.subscribe((isLoaded) => {
                                if (isLoaded) {
                                    this.onSuccess.emit();
                                }
                            }));
                        }
                        this.onSuccess.emit();
                    }
                });
            }
        });
    }
}
